module.exports = __webpack_public_path__ + "img/discord.0fe3e4e9.svg";